import {ItemDto} from '../../../../models/Items/IItem';
import {GuidLightDto} from '../../../../models/common/IGuidLight';
import {SaveFillingGuidRequest} from '../../../../models/Recipe/Filling/IFillingGuid';
import FillingForm from '../../shared/FillingForm';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

interface Props { items?: ItemDto[]; recipes?: GuidLightDto[]; onSubmit: (value: SaveFillingGuidRequest) => Promise<void>; }
export default function CreateFilling({items, recipes, onSubmit}: Props) {
    const {t} = useAppTranslation();
    return <FillingForm items={items} recipes={recipes} onSubmit={onSubmit} submitLabel={t('recipes:save_filling')}/>;
}
